(() => {
  'use strict';

  const BUYBOX_HASH = '#bravorn-buybox';
  const REVIEWS_HASH = '#bravorn-reviews';
  const OFFSET = 20;

  function isBravornLanding() {
    return document.documentElement.classList.contains('bravorn-landing-active');
  }

  function getBuyboxTarget() {
    const marker = document.querySelector(BUYBOX_HASH);

    if (marker) {
      const productInfo = marker.closest('product-info[id^="MainProduct-"]');
      if (productInfo) return productInfo;
    }

    return (
      document.querySelector('product-info[id^="MainProduct-"]') ||
      document.querySelector('.shopify-section[id*="__main"] product-info') ||
      marker ||
      document.querySelector('.shopify-section[id*="__main"] .product')
    );
  }

  function getReviewsTarget() {
    return (
      document.querySelector('.bravorn-reviews-model') ||
      document.querySelector('[id^="BravornReviewsExtended-"]') ||
      document.querySelector('.shopify-section[id*="__reviews_bottom"]')
    );
  }

  function smoothScrollTo(target) {
    if (!target) return false;

    const top = Math.max(
      0,
      target.getBoundingClientRect().top + window.pageYOffset - OFFSET
    );

    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });

    return true;
  }

  function goToBuybox(event) {
    const target = getBuyboxTarget();
    if (!target) return;

    if (event) event.preventDefault();
    smoothScrollTo(target);
  }

  function goToReviews(event) {
    const target = getReviewsTarget();
    if (!target) return;

    if (event) event.preventDefault();
    smoothScrollTo(target);
  }

  function prepareReviewLinks(root = document) {
    const selectors = [
      '.bravorn-lp-hero .bravorn-lp__proof',
      '.bravorn-lp-reviews-top .bravorn-lp__proof',
      '.bravorn-buybox-rating'
    ];

    selectors.forEach((selector) => {
      root.querySelectorAll(selector).forEach((element) => {
        if (element.dataset.bravornReviewsReady === 'true') return;

        element.dataset.bravornReviewsReady = 'true';
        element.dataset.bravornReviewsLink = 'true';

        element.setAttribute('role', 'link');
        element.setAttribute('tabindex', '0');
        element.setAttribute('title', 'Voir les avis vérifiés');
        element.style.cursor = 'pointer';
      });
    });
  }

  function handleClick(event) {
    if (!isBravornLanding()) return;

    const buyboxLink = event.target.closest('a[href*="#bravorn-buybox"]');

    if (buyboxLink) {
      let isBuyboxLink = false;

      try {
        isBuyboxLink =
          new URL(buyboxLink.href, window.location.href).hash === BUYBOX_HASH;
      } catch (_) {
        isBuyboxLink =
          buyboxLink.getAttribute('href') === BUYBOX_HASH;
      }

      if (isBuyboxLink) {
        goToBuybox(event);
        return;
      }
    }

    const reviewsLink = event.target.closest(
      `a[href="${REVIEWS_HASH}"], [data-bravorn-reviews-link="true"]`
    );

    if (reviewsLink) {
      goToReviews(event);
    }
  }

  function handleKeydown(event) {
    if (!isBravornLanding()) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const reviewsLink = event.target.closest(
      '[data-bravorn-reviews-link="true"]'
    );

    if (!reviewsLink) return;

    event.preventDefault();
    goToReviews();
  }

  function init(root = document) {
    if (!isBravornLanding()) return;
    prepareReviewLinks(root);
  }

  document.addEventListener('click', handleClick, true);
  document.addEventListener('keydown', handleKeydown);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();